import HTMLTemplate from './template.html'
import './styles.scss'
import TutorialPanel1BG from '../../resources/images/tutorial-slide-start.png'
import TutorialPanel2BG from '../../resources/images/tutorial-slide-1.png'
import TutorialPanel3BG from '../../resources/images/tutorial-slide-2.png'
import TutorialPanel4BG from '../../resources/images/tutorial-slide-3.png'
import TutorialPanel5BG from '../../resources/images/tutorial-slide-4.png'
import TutorialPanel3BGBG from '../../resources/images/tuorial-slide-3-bg.png'
import TutorialPanel6BG from '../../resources/images/tutorial-slide-5.png'

export const TutorialComponent = (() => {
    var vueComponent = {
        data() {
            return {
                showTutorial: false,
                firstTimeSeeing: false,
                currentStep: 0, // Initial tutorial step
                tutorialPanelImage1: TutorialPanel1BG,
                tutorialPanelImage2: TutorialPanel2BG,
                tutorialPanelImage3: TutorialPanel3BG,
                tutorialPanelImage4: TutorialPanel4BG,
                tutorialPanelImage5: TutorialPanel5BG,
                tutorialPanelImage3BG: TutorialPanel3BGBG,
                tutorialPanelImage6: TutorialPanel6BG
            }
        },
        created() {
            if (window.localStorage.getItem('tutorial-seen') === null) {
                this.firstTimeSeeing = true   
                this.show()
            }
        },
        methods: {
            show() {
                this.showTutorial = true
                document.getElementsByClassName('app-template')[0].classList.add('show-tutorial-modal')
            },
            hide() {
                this.showTutorial = false
                document.getElementsByClassName('app-template')[0].classList.remove('show-tutorial-modal')

                // Remember also that user hide the tutorial, so we don't display it each time
                window.localStorage.setItem('tutorial-seen', 'true')
            },
            showHelp() {
                this.firstTimeSeeing = false
                this.currentStep = 0
                this.show()
            },
            goStep(stepNumber) {
                this.currentStep = stepNumber
            },
            nextStep() {
                this.currentStep = this.currentStep + 1
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-tutorial')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})()
